import { render, staticRenderFns } from "./StartFromScratchCard.vue?vue&type=template&id=7ba495cf&scoped=true"
import script from "./StartFromScratchCard.vue?vue&type=script&lang=js"
export * from "./StartFromScratchCard.vue?vue&type=script&lang=js"
import style0 from "./StartFromScratchCard.vue?vue&type=style&index=0&id=7ba495cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba495cf",
  null
  
)

export default component.exports